export default __webpack_public_path__ + "static/media/Primer-Paints.f7682a10.jpg";